import React, { useEffect, useRef, useState } from 'react';
import GradientBorder from '../../ui/GradientBorder';
import WhiteCard from '../../ui/WhiteCard';
import Loader from '../../ui/Loader';
import { useNavigate } from 'react-router-dom';
import EmptyArray from '../../ui/EmptyArray';
import { getAchievments } from '../../apis/geenpills/apis';
import { achievmentsData, allAchievementImages } from '../../constants/achievmentsData';
import { useLoadingState } from '../../hooks/useLoader';
import SelectedAchievmentModal from './SelectedAchievmentModal';
import Heading from '../../ui/Heading';
import Button from '../../ui/Button';
import ArrowRight from '../../assets/icons/ArrowRight';
import ArrowLeft from '../../assets/icons/ArrowLeft';
import NoDataAvailable from '../../ui/NoDataAvailable';

const Achievment = () => {
    const navigate = useNavigate();
    const dispatch = () => {};
    const scrollCards = useRef();
    const [selectedAchievment, setSelectedAchievment] = useState('');
    const greenPillNFTsHoldByWalletAddress = [];
    const [isModalOpen, setModalOpen] = useState(false);
    const [impactsAchieved, setImpactsAchieved] = useState([]);
    const { loading, startLoading, stopLoading } = useLoadingState();
    function scrollR() {
        scrollCards.current.scrollBy({
            left: 334,
            behavior: 'smooth',
        });
    }
    function scrollL() {
        scrollCards.current.scrollBy({
            left: -334,
            behavior: 'smooth',
        });
    }

    useEffect(function () {
        const fetchData = async () => {
            try {
                startLoading();
                const data = await getAchievments();

                setImpactsAchieved(data);
            } catch (error) {
                console.log(error);
            } finally {
                stopLoading();
            }
        };
        fetchData();
    }, []);
    const handleOpenModal = (achievmentId) => {
        setSelectedAchievment(achievmentId); // Set the selected bounty
        setModalOpen(true); // Open the modal
    };

    const handleCloseModal = () => {
        setModalOpen(false); // Close the modal
        setSelectedAchievment('');
    };

    const availableCards = allAchievementImages
        .map((achievment) => {
            const achievmentFound = impactsAchieved?.find((ic) => ic?.activityType === achievment?.type) || {
                activityType: achievment?.type,
                milestones: [],
            };
            const card = {
                ...achievmentFound,
                keyType: achievment?.type,
                id: achievment?.id,
                key: achievment?.key,
                label: achievment?.label,
                image: achievment?.image,
                isNotGradeOut: achievmentFound?.milestones?.includes(achievment?.key),
                texts: achievment?.texts,
            };
            return card;
        })
        .filter((a) => a?.isNotGradeOut);

    return (
        <div className="mt-12">
            <div className="flex items-center justify-between">
                <Heading className={`text-textGrayHeading leading-10`} type={'medium'}>
                    Achievments
                </Heading>
                <p
                    onClick={() => navigate('/profile/activityHistory')}
                    className="underline cursor-pointer font-medium text-textGrayHeading leading-4"
                >
                    View Activity History
                </p>
            </div>

            {/* <GradientBorder
                radiusBorder=".4rem"
                color1="rgba(84, 84, 84, 1)"
                color2="rgba(84, 84, 84, 0.38)"
                isNoBottomRadius={false}
                width="w-full"
                bg="bg-background"
                upperPadding="p-6"
                borderThickness="1px"
                className=""
            > */}
            <div className="relative">
                <div
                    bg={'bg-[#f6f6f6]'}
                    verticalMargin=""
                    ref={scrollCards}
                    className="  flex overflow-x-auto  gap-3  flex-nowrap items-stretch  scrollableCards"
                >
                    {allAchievementImages.map((achievment) => {
                        //  {
                        //     type: 'ISSUE_MONETARY_REWARD',
                        //     id: 'imr10000',
                        //     key: 10000,
                        //     image: monetaryRewards10000,
                        //     texts: {
                        //         first: 'Deployed $10,000 in Impact Funds',
                        //         second: '',
                        //     },
                        // },
                        const achievmentFound = impactsAchieved?.find(
                            (ic) => ic?.activityType === achievment?.type
                        ) || { activityType: achievment?.type, milestones: [] };
                        const card = {
                            ...achievmentFound,
                            keyType: achievment?.type,
                            id: achievment?.id,
                            key: achievment?.key,
                            label: achievment?.label,
                        };

                        const isNotGradeOut = achievmentFound?.milestones?.includes(card?.key);

                        return (
                            <div
                                onClick={() => {
                                    if (isNotGradeOut) {
                                        handleOpenModal(card?.id);
                                    } else {
                                        return;
                                    }
                                }}
                                className={`bg-[#252525] rounded-lg p-3 flex flex-col gap-[.375rem]   `}
                            >
                                <div
                                    key={achievment?.id}
                                    className="container cursor-pointer flex flex-col gap-[.375rem] rounded-lg w-[7.5rem]"
                                >
                                    <div
                                        className={`w-[7.5rem] h-[10.5rem] rounded-lg overflow-hidden flex items-center justify-center  ${
                                            !isNotGradeOut ? 'opacity-50 grayscale cursor-not-allowed' : ''
                                        } `}
                                    >
                                        <img
                                            className="w-full h-full object-cover"
                                            src={achievment?.image}
                                            alt="greenpill-card"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <p className="text-xs text-center font-medium text-white">
                                        {achievment?.texts?.first}
                                    </p>
                                    <p className="text-xs text-center text-[#CFCFCF] font-medium mt-1">
                                        {achievment?.texts?.second}
                                    </p>
                                </div>
                            </div>
                        );
                    })}

                    <Button
                        radius="rounded-full"
                        onClick={scrollL}
                        className="bg-[#EAEAEA] absolute top-[50%] translate-y-[-50%]  -left-[3.15rem] "
                        variant="tertiary"
                        size="circle"
                    >
                        <ArrowLeft fillColor="#606060" />
                    </Button>

                    <Button
                        radius="rounded-full"
                        onClick={scrollR}
                        className="bg-[#EAEAEA] absolute top-[50%] translate-y-[-50%]  -right-[3.15rem] "
                        variant="tertiary"
                        size="circle"
                    >
                        <ArrowRight fillColor={'#606060'} />
                    </Button>
                </div>
            </div>

            {/* </GradientBorder> */}
            {isModalOpen && (
                <div>
                    <SelectedAchievmentModal
                        close={handleCloseModal}
                        selectedAchievment={selectedAchievment}
                        availableAchievments={availableCards}
                    />
                </div>
            )}
        </div>
    );
};

export default Achievment;
